<div class="collapse-component">
  <div class="collapse-component__box">
    <p class="collapse-component__text" [innerHTML]="text | translate"></p>
    <div class="collapse-component__content" [class.collapse-component__content--expanded]="expanded">
      <p class="collapse-component__text collapse-component__text--extended" [innerHTML]="collapseText | translate"></p>
    </div>
    <button type="button" class="collapse-component__trigger" (click)="toggle()" [attr.aria-expanded]="expanded">
      {{ (expanded ? "COMMON.HIDE_COLLAPSE" : "COMMON.SHOW_COLLAPSE") | translate }}
      <img
        class="collapse-component__chevron"
        [class.collapse-component__chevron--open]="expanded"
        src="../../../../assets/svg/arrow_down_grey.svg"
        alt=""
      />
    </button>
  </div>
</div>
